import React from "react";
import { BACKEND_URL } from "../util/api";

const Hero = ({ data }) => {
  const {
    profile,
    office,
    constituency,
  } = data || {};

  // Prevent rendering errors while API data is loading
  if (!profile || !office || !constituency) {
    return null;
  }

  return (
    <section
      className="hero"
      id="home"
      aria-labelledby="hero-title"
    >
      <div
        className="hero-pattern"
        aria-hidden="true"
      />

      <div
        className="hero-orbit orbit-one"
        aria-hidden="true"
      />

      <div
        className="hero-orbit orbit-two"
        aria-hidden="true"
      />

      <div className="container hero-container">

        {/* =========================
            HERO CONTENT
        ========================== */}
        <div className="hero-content">

          <p className="eyebrow">
            <span />
            PUBLIC SERVICE • LEADERSHIP • REPRESENTATION
          </p>

          <h1 id="hero-title">
            {profile.title}{" "}
            {profile.first_name}

            <span>
              {profile.middle_name}{" "}
              {profile.last_name}
            </span>
          </h1>

          {/* =========================
              POSITION
          ========================== */}
          <div className="hero-position">

            <span
              className="position-line"
              aria-hidden="true"
            />

            <div>

              <strong>
                {office.position},{" "}
                {office.office}
              </strong>

              <p>
                {office.role_description}
              </p>

            </div>

          </div>

          {/* =========================
              OFFICE META
          ========================== */}
          <div
            className="hero-meta"
            aria-label="Public office information"
          >

            <div>
              <span>
                {office.institution_label}
              </span>

              <strong>
                {office.institution_value}
              </strong>
            </div>

            <div>
              <span>
                {office.constituency_label}
              </span>

              <strong>
                {office.constituency ||
                  constituency.constituency}
              </strong>
            </div>

            <div>
              <span>TENURE</span>

              <strong>
                {office.start_year} —{" "}
                {office.end_year}
              </strong>
            </div>

          </div>

          {/* =========================
              BUTTONS
          ========================== */}
          <div className="hero-buttons">

            <a
              href="#about"
              className="btn btn-primary"
            >
              Discover His Work

              <span aria-hidden="true">
                →
              </span>
            </a>

            <a
              href="#contact"
              className="btn btn-outline"
            >
              Contact the Office
            </a>

          </div>

          {/* =========================
              TRUST MESSAGE
          ========================== */}
          <div className="hero-trust">

            <span
              className="trust-dot"
              aria-hidden="true"
            />

            <span>
              Official public information &amp;
              constituency communication
            </span>

          </div>

        </div>

        {/* =========================
            HERO IMAGE
        ========================== */}
        <div className="hero-image-wrapper">

          <div
            className="hero-glow"
            aria-hidden="true"
          />

          <div className="hero-image-frame">

            <img
              src={BACKEND_URL +"/storage/"+ profile.image}
              alt={`${profile.full_name}, ${office.position} of ${office.office}`}
            />

            <div
              className="image-overlay"
              aria-hidden="true"
            />

            <div className="image-caption">

              <span>
                PUBLIC OFFICE
              </span>

              <strong>
                {office.office}
              </strong>

            </div>

          </div>

          {/* =========================
              HERO BADGE
          ========================== */}
          <div
            className="hero-badge"
            aria-label={`${office.institution_value}, ${office.office}`}
          >

            <span
              className="badge-icon"
              aria-hidden="true"
            >
              ✦
            </span>

            <div>

              <strong>
                {office.institution_value}
              </strong>

              <small>
                {office.office}
              </small>

            </div>

          </div>

        </div>

      </div>

      {/* =========================
          HERO BOTTOM
      ========================== */}
      <div className="hero-bottom">

        <div className="container hero-bottom-inner">

          <span>
            REPRESENTING
          </span>

          <strong>
            {office.constituency ||
              constituency.constituency}{" "}
            Constituency
          </strong>

          <a href="#constituency">

            Explore Constituency

            <span aria-hidden="true">
              →
            </span>

          </a>

        </div>

      </div>

    </section>
  );
};

export default Hero;